import React, {useEffect, useState} from 'react';
import {useRouteMatch} from "react-router-dom";
import {Box, Button, Chip, Grid, Paper, TextField} from "@material-ui/core";
import {BlockRounded, CheckCircleOutlineRounded} from "@material-ui/icons";
import {useSnackbar} from "notistack";
import {useConfirm} from "material-ui-confirm";
import {useVendedoresService} from "services/hooks";
import SubHeader from "components/helpers/subHeader/subHeader";
import {COLOR_INHABILITADO} from "components/vendedores/list/vendedores.list";

const COLOR_DESHABILITAR = '#d32f2f';
const COLOR_HABILITAR = '#388e3c';

// Campo de solo lectura para los datos del vendedor.
const Dato = ({label, value, xs = 12, sm = 6}) => (
    <Grid item xs={xs} sm={sm}>
        <TextField
            fullWidth
            label={label}
            value={value || '-'}
            InputProps={{readOnly: true, disableUnderline: true}}
        />
    </Grid>
);

// Los datos del vendedor vienen del maestro de Admicont y no se editan desde acá:
// lo único que se cambia es si está habilitado o inhabilitado.
export const VendedoresEdit = () => {
    const VendedoresService = useVendedoresService();
    const {enqueueSnackbar} = useSnackbar();
    const confirm = useConfirm();
    const match = useRouteMatch();

    const idVendedor = match.params.vendedor;
    const [vendedor, setVendedor] = useState(null);

    useEffect(() => {
        VendedoresService.getFicha(
            idVendedor,
            response => setVendedor(response.data.result),
            error => enqueueSnackbar(error, {variant: 'error'})
        );
    }, [idVendedor]);

    const setInhabilitado = inhabilitado => {
        VendedoresService.setInhabilitado(
            idVendedor,
            inhabilitado,
            response => {
                setVendedor(response.data.result);
                enqueueSnackbar(`El vendedor se ${inhabilitado ? 'deshabilitó' : 'habilitó'} correctamente.`, {variant: 'success'});
            },
            error => enqueueSnackbar(error, {variant: 'error'})
        );
    };

    const onInhabilitar = () => {
        confirm({
            title: '¿Deshabilitar el vendedor?',
            description: 'El vendedor no se borra del sistema, se conserva toda su historia y se lo puede volver a habilitar.',
            confirmationText: 'Sí, deshabilitar',
            cancellationText: 'Cancelar'
        })
            .then(() => setInhabilitado(true))
            .catch(() => {
            });
    };

    const formatZona = () => vendedor.zona ? `${vendedor.zona}${vendedor.zonanombre ? ` - ${vendedor.zonanombre}` : ''}` : '';

    return (
        <Box className='niquel-vendedores-edit'>
            <SubHeader
                title={'Vendedores'}
                subtitle={'Editar vendedor'}
            />
            {vendedor && (
                <Box className='container-sm mt-3 mb-3'>
                    <Box className='d-flex align-items-center justify-content-between mb-2'>
                        <Box>
                            {vendedor.inhabilitado ?
                                <Chip size={"small"} style={{backgroundColor: COLOR_INHABILITADO}} label={`Deshabilitado desde el ${vendedor.inhabilitacion}`}/> :
                                <Chip size={"small"} label={'Habilitado'}/>}
                        </Box>
                        {vendedor.inhabilitado ? (
                            <Button
                                variant={"contained"}
                                style={{backgroundColor: COLOR_HABILITAR, color: '#fff'}}
                                startIcon={<CheckCircleOutlineRounded/>}
                                onClick={() => setInhabilitado(false)}
                            >
                                Habilitar
                            </Button>
                        ) : (
                            <Button
                                variant={"contained"}
                                style={{backgroundColor: COLOR_DESHABILITAR, color: '#fff'}}
                                startIcon={<BlockRounded/>}
                                onClick={onInhabilitar}
                            >
                                Deshabilitar
                            </Button>
                        )}
                    </Box>
                    <Paper className='p-3'>
                        <Grid container spacing={2}>
                            <Dato label={'Nombre'} value={vendedor.apenom} sm={6}/>
                            <Dato label={'ID'} value={vendedor.id} sm={3}/>
                            <Dato label={'Categoría'} value={vendedor.categoria} sm={3}/>
                            <Dato label={'Email'} value={vendedor.email} sm={6}/>
                            <Dato label={'Zona'} value={formatZona()} sm={6}/>
                            <Dato label={'Supervisor'} value={vendedor.supervisor} sm={6}/>
                            <Dato label={'ID Supervisor'} value={vendedor.idsupervisor} sm={6}/>
                            <Dato label={'Dirección'} value={vendedor.direccion} sm={6}/>
                            <Dato label={'Ciudad'} value={vendedor.ciudad} sm={6}/>
                        </Grid>
                    </Paper>
                </Box>
            )}
        </Box>
    );
};
